import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";
const _preActionName = Pre.SIREN;

export function turnOn(deviceId = 0, deviceUId = null, accessToken) {
  return {
    type: _preActionName + Actions.UPDATE_VALUE,
    accessToken: accessToken,
    payload: { deviceId, deviceUId, value: true },
    socket: { send: true, keepSocket: true },
  };
}

export function turnOff(deviceId = 0, deviceUId = null, accessToken) {
  return {
    type: _preActionName + Actions.UPDATE_VALUE,
    accessToken: accessToken,
    payload: { deviceId, deviceUId, value: false },
    socket: { send: true, keepSocket: true },
  };
}
